var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurgical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8795 11.5947L9.93577 21.5384L3.30664 14.9093L13.2503 4.96561",
    stroke: "#6C6D8A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4092 3.12415L21.7212 13.4361",
    stroke: "#6C6D8A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72559 14.9093L9.93529 17.119",
    stroke: "#6C6D8A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.30664 21.538L6.6208 18.2238",
    stroke: "#6C6D8A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5645 8.28015L18.4055 6.43913",
    stroke: "#6C6D8A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurgical);
export default __webpack_public_path__ + "static/media/surgical.cdd5694dedd04207b1d86b22ab06c537.svg";
export { ForwardRef as ReactComponent };